export const Calendar =
{
	'HOLDATE': 'HOLIDAYS-HOLDATE',
	'HOLDESC': 'HOLIDAYS-HOLDESC',
	'B_IS_FROM_SERVICE': 'CALENDAR-B_IS_FROM_SERVICE',
	'B_SET_RANGE': 'CALENDAR-B_SET_RANGE',
	'B_UNSET_RANGE': 'CALENDAR-B_UNSET_RANGE',
	'CALDESC': 'CALENDAR-CALDESC',
	'CALNAME': 'CALENDAR-CALNAME',
	'EFFECTIVE_DATE': 'EFFECTIVE_DATE',
	'ISDEF': 'CALENDAR-ISDEF',
	'PROFILE_CHANGE_STATUS': 'CALENDAR-PROFILE_CHANGE_STATUS',
	'REC_STATUS': 'CALENDAR-REC_STATUS',
	'WEEKENDSDAYS': 'CALENDAR-WEEKENDSDAYS',
	'TIME_STAMP': 'TIME_STAMP',
	'UID': 'VIRTUAL-UID',
	'PROFILE_UPDATE_PK': 'PROFILE_UPDATE_PK',
	'PU_TIME_STAMP': 'PU_TIME_STAMP',
	'NOTE': 'NOTE',
	'V_FRIDAY': 'CALENDAR-V_FRIDAY',
	'V_MONDAY': 'CALENDAR-V_MONDAY',
	'V_SATURDAY': 'CALENDAR-V_SATURDAY',
	'V_SUNDAY': 'CALENDAR-V_SUNDAY',
	'V_THURSDAY': 'CALENDAR-V_THURSDAY',
	'V_TUESDAY': 'CALENDAR-V_TUESDAY',
	'V_WEDNESDAY': 'CALENDAR-V_WEDNESDAY',
};
